import TourPage from "@/components/TourPage";

export default function BwindiGorilla5Day() {
  return (
    <TourPage
      tourId="uganda/bwindi-gorilla-5-day"
      title="5-Day Bwindi Impenetrable National Park Gorilla Safari"
      duration="5 Days / 4 Nights"
      price="Contact for price"
  image="/gorilla.webp"
      description="Embark on an unforgettable journey to Bwindi Impenetrable Forest, home to half of the world's remaining mountain gorillas. This 5-day safari combines gorilla trekking with cultural experiences and scenic exploration."
      itinerary={[
        {
          day: 1,
          title: "Kampala to Lake Mburo National Park",
          description:
            "Begin your journey with a visit to Lake Mburo National Park.",
          activities: [
            "Morning departure from Kampala",
            "Drive to Lake Mburo National Park",
            "Evening game drive",
            "Dinner and overnight at the lodge",
          ],
          accommodation: "Mihingo Lodge or similar",
          meals: "Lunch, Dinner",
        },
        {
          day: 2,
          title: "Lake Mburo to Bwindi Impenetrable Forest",
          description: "Travel to the magnificent Bwindi Impenetrable Forest.",
          activities: [
            "Morning nature walk in Lake Mburo",
            "Drive to Bwindi through scenic landscapes",
            "Evening arrival at Bwindi",
            "Briefing about gorilla trekking",
          ],
          accommodation: "Bwindi Lodge or similar",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 3,
          title: "Gorilla Trekking",
          description: "The highlight of your safari - gorilla trekking.",
          activities: [
            "Early morning briefing",
            "Gorilla trekking in the forest",
            "Spend one hour with the gorillas",
            "Return to lodge for relaxation",
            "Optional community visit",
          ],
          accommodation: "Bwindi Lodge or similar",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 4,
          title: "Second Gorilla Trek or Forest Walk",
          description:
            "Choose between another gorilla trek or forest exploration.",
          activities: [
            "Optional second gorilla trek (additional permit required)",
            "Or forest walk to see other primates",
            "Visit to the Batwa community",
            "Cultural performances and demonstrations",
          ],
          accommodation: "Bwindi Lodge or similar",
          meals: "Breakfast, Lunch, Dinner",
        },
        {
          day: 5,
          title: "Return to Kampala",
          description: "Journey back to Kampala with scenic stops.",
          activities: [
            "Morning departure from Bwindi",
            "Drive back to Kampala",
            "Stop at the equator for photos",
            "Evening arrival in Kampala",
          ],
          meals: "Breakfast, Lunch",
        },
      ]}
      inclusions={[
        "Gorilla permit",
        "Park entrance fees",
        "4x4 safari vehicle",
        "English-speaking guide",
        "Accommodation as listed",
        "Meals as specified",
        "Bottled water",
        "Game drives and activities mentioned",
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips for guides",
        "Additional gorilla permit",
        "Drinks and beverages",
        "Optional activities",
      ]}
    />
  );
}